import React__default from 'react';
import { u as useFormStage } from './hooks/useStage-C5gC2haD.js';
import { F as FormLayoutDisclaimer } from './FormLayoutDisclaimer-tjJTTliS.js';
import { F as FormLayoutPrompt } from './FormLayoutPrompt-iACIoUki.js';
import { S as SuccessMessageContainer, F as FooterSuccessInlineMessage, C as ContentContainer, a as ContentForm } from './FormLayout.styles-BzYy_4z2.js';

const FormLayoutContent = ({
  children,
  formContext,
  hideActions,
  isMobile,
  renderDisclaimer,
  renderPrompt,
  renderSuccess = 'Your feedback was submitted.',
  resubmitEnabled
}) => {
  const {
    id,
    label,
    handleSubmit
  } = formContext;
  const {
    stage
  } = useFormStage();
  if (stage === 'submitted') {
    return /*#__PURE__*/React__default.createElement(SuccessMessageContainer, {
      $hideActions: hideActions,
      $isMobile: isMobile,
      $resubmitEnabled: resubmitEnabled
    }, typeof renderSuccess === 'function' ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, renderSuccess()) : /*#__PURE__*/React__default.createElement(FooterSuccessInlineMessage, {
      messageType: "success",
      message: renderSuccess
    }));
  }
  return /*#__PURE__*/React__default.createElement(ContentContainer, {
    $isMobile: isMobile
  }, /*#__PURE__*/React__default.createElement(FormLayoutPrompt, {
    renderPrompt: renderPrompt
  }), /*#__PURE__*/React__default.createElement(ContentForm, {
    id: id,
    "aria-label": label,
    onSubmit: handleSubmit
  }, typeof children === 'function' ? children(formContext) : children, renderDisclaimer && /*#__PURE__*/React__default.createElement(FormLayoutDisclaimer, {
    renderDisclaimer: renderDisclaimer
  })));
};

export { FormLayoutContent as F };
//# sourceMappingURL=FormLayoutContent-Dj1L2Ajy.js.map
